import React from 'react';
import FilterRowItem from './FilterRowItem';
import PropTypes from 'prop-types';

export default function FilterRow(props) {
  const { appliedFilterObj, filterObject, dataAttributes } = props;
  return (
    <div className="filter-applied" {...dataAttributes}>
      <ul className="list-unstyled flex-centered">
        {appliedFilterObj &&
          Object.keys(appliedFilterObj).map((key) => {
            if (filterObject[key].multiValue) {
              return appliedFilterObj[key]
                .split(',')
                .map((valueItem, index) => (
                  <FilterRowItem
                    key={index}
                    filterLabel={filterObject[key]?.label}
                    filterValue={
                      filterObject[key]?.options &&
                      filterObject[key]?.options.length
                        ? filterObject[key]?.options.find((item) => {
                            return item.value == valueItem;
                          }).label
                        : valueItem
                    }
                    handleRemoveFilterClick={(key) =>
                      props.handleRemoveFilterClick(key, valueItem)
                    }
                    name={key}
                    disabled={
                      appliedFilterObj.status
                        ? appliedFilterObj.status == 'EXPIRED' &&
                          valueItem == 'ACCEPTED'
                          ? true
                          : false
                        : false
                    }
                  />
                ));
            } else {
              return (
                <FilterRowItem
                  key={key}
                  filterLabel={filterObject[key]?.label}
                  filterValue={
                    filterObject[key]?.options &&
                    filterObject[key]?.options.length
                      ? filterObject[key]?.options.find((item) => {
                          return item.value == appliedFilterObj[key];
                        })?.label
                      : appliedFilterObj[key]
                  }
                  handleRemoveFilterClick={props.handleRemoveFilterClick}
                  name={key}
                />
              );
            }
          })}
        {Object.keys(appliedFilterObj).length && (
          <li
            className="clear-filter"
            onClick={() => {
              props.handleClearFilter();
            }}
          >
            Clear all filters
          </li>
        )}
      </ul>
    </div>
  );
}
FilterRow.propTypes = {
  appliedFilterObj: PropTypes.object.isRequired,
  filterObject: PropTypes.object.isRequired,
};
